export enum EmailTemplateKind {
  Personal = 'personal',
  Company = 'company',
}
